// extracted by mini-css-extract-plugin
module.exports = {"input":"_2787e5dfdf--input--UfX_d","postfix":"_2787e5dfdf--postfix--Ijv2s"};